import { Injectable } from '@angular/core';
import { ApiService } from '@us/web/shared/data-access';
import { Observable } from 'rxjs';
import { Inventory } from './inventory.models';

@Injectable({
    providedIn: 'root'
})
export class InventoryService {
    constructor(private apiService: ApiService) {}

    getData(): Observable<Inventory[]> {
        return this.apiService.get('shop/products/quantity-in-stock');
    }
}
